import React from "react";

import { LeadFormFlags } from "client/defs";

import { LeadFormFieldUiMap } from "client/domain/FormBuilder/LeadForm/LeadForm";
import { YesOrNoQuestionsHeader } from "client/domain/FormBuilder/YesOrNoQuestionsHeader";

type Page = {
  name: string;
  headingCopyKey: string;
  subHeadingCopyKey?: string;
};

type Config = { pages: Page[] };

// contact first
const configVariantA: Config = {
  pages: [
    {
      name: "business-info",
      headingCopyKey: "uiLeadFormHeading",
      subHeadingCopyKey: "uiLeadFormSubHeading",
    },
    {
      name: "additional-business-info",
      headingCopyKey: "uiLeadFormAdditionalInfoHeading",
    },
    {
      name: "business-size",
      headingCopyKey: "uiLeadFormHeadingBusinessSize",
      subHeadingCopyKey: "uiLeadFormSubHeadingBusinessSize",
    },
    {
      name: "contact",
      headingCopyKey: "uiLeadFormHeadingContact",
    },
  ],
};

// contact first
const configVariantB: Config = {
  pages: [
    {
      name: "contact",
      headingCopyKey: "uiLeadFormHeadingContact",
    },
    {
      name: "business-info",
      headingCopyKey: "uiLeadFormHeading",
      subHeadingCopyKey: "uiLeadFormSubHeading",
    },
    {
      name: "additional-business-info",
      headingCopyKey: "uiLeadFormAdditionalInfoHeading",
    },
    {
      name: "business-size",
      headingCopyKey: "uiLeadFormHeadingBusinessSize",
      subHeadingCopyKey: "uiLeadFormSubHeadingBusinessSize",
    },
  ],
};

// contact last page
const uiFieldMapVariantA: LeadFormFieldUiMap = {
  lead: {
    registeredCountry: { pageNumber: 1 },
    industry: { pageNumber: 1 },
    subIndustry: { pageNumber: 1, width: 12 },
    storeName: { pageNumber: 1, width: 12 },

    salesChannel: { pageNumber: 2, width: 12 },
    contactlessPayment: { pageNumber: 2, width: 12 },
    platform: { pageNumber: 2, width: 12 },
    acquirer: { pageNumber: 2, width: 12 },
    // YES/NO risk questions begin
    franchisee: {
      customFieldHeader: <YesOrNoQuestionsHeader />,
      pageNumber: 2,
      width: 12,
    },
    franchiseName: { pageNumber: 2, width: 12 },
    // YES/NO risk questions end

    totalAnnualSales: { pageNumber: 3, width: 12 },
    totalAnnualSalesInStore: { pageNumber: 3, width: 12 },
    numOfStores: { pageNumber: 3, width: 12 },

    firstName: { pageNumber: 4 },
    lastName: { pageNumber: 4 },
    phone: { pageNumber: 4, width: 12 },
    website: { pageNumber: 4, width: 12 },
    email: { pageNumber: 4, width: 12 },
  },
};

// contact first page
const uiFieldMapVariantB: LeadFormFieldUiMap = {
  lead: {
    firstName: { pageNumber: 1 },
    lastName: { pageNumber: 1 },
    phone: { pageNumber: 1, width: 12 },
    website: { pageNumber: 1, width: 12 },
    email: { pageNumber: 1, width: 12 },

    registeredCountry: { pageNumber: 2 },
    industry: { pageNumber: 2 },
    subIndustry: { pageNumber: 2, width: 12 },
    storeName: { pageNumber: 2, width: 12 },

    salesChannel: { pageNumber: 3, width: 12 },
    contactlessPayment: { pageNumber: 3, width: 12 },
    platform: { pageNumber: 3, width: 12 },
    acquirer: { pageNumber: 3, width: 12 },
    // YES/NO risk questions begin
    franchisee: {
      customFieldHeader: <YesOrNoQuestionsHeader />,
      pageNumber: 3,
      width: 12,
    },
    franchiseName: { pageNumber: 3, width: 12 },
    // YES/NO risk questions end

    totalAnnualSales: { pageNumber: 4, width: 12 },
    totalAnnualSalesInStore: { pageNumber: 4, width: 12 },
    numOfStores: { pageNumber: 4, width: 12 },
  },
};

type PageConfigs = {
  [key in LeadFormFlags]?: Config;
};

type UIFieldMapConfigs = {
  [key in LeadFormFlags]?: LeadFormFieldUiMap;
};

const configs: PageConfigs = {
  "1QAAT_4page_contact_first": configVariantB,
  "1QAAT_4page_contact_last": configVariantA,
};

const uiFieldMaps: UIFieldMapConfigs = {
  "1QAAT_4page_contact_first": uiFieldMapVariantB,
  "1QAAT_4page_contact_last": uiFieldMapVariantA,
};

export { configVariantA, uiFieldMapVariantA, configs, uiFieldMaps };
